module.exports = __webpack_public_path__ + "static/img/product-wrightinMulan.eb383e40.png";